import type { Color } from '../../types/game'
import { assetUrl } from '../../utils/assets'

interface WorkerProps {
  color: Color
  size?: string
  showImage?: boolean
}

export function Worker({ color, size, showImage = true }: WorkerProps) {
  return (
    <div
      className="worker"
      style={{
        background: `var(--${color})`,
        ...(size ? { '--worker-size': size } as React.CSSProperties : {}),
      }}
    >
      {showImage ? (
        <img
          src={assetUrl('images', 'resources', 'worker.svg')}
          alt=""
          className="icon"
        />
      ) : null}
    </div>
  )
}
